//TODO: this StringFormatterService may be available to import from app/shared
import { StringFormatterService } from "app/shared/service/string-formatter.service";
import { Component, Input, NgZone, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsFilter,
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  TimePeriod,
  ExportService,
  LoggingService,
  UsersTotalData,
  UserLineChartDataPoint,
} from "app/shared";
import {
  ChartOptions,
  ChartData,
  ChartType,
  Plugin,
  ChartTypeRegistry,
} from "chart.js";
import {
  UserAnalyticConfiguration,
  UsersTotalConfig,
} from "app/shared/model/charts/user-analytic-configurations.model";
import {
  ChartDefinition,
  ChartDefinitions,
} from "app/analytics/chartDefinitions.config";
import { AnyObject } from "chart.js/dist/types/basic";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";

@Component({
  selector: "users-total-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class UsersTotalChartComponent
  extends BaseChartLogic<UsersTotalConfig, UsersTotalData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;

  public totalUsersData: ChartData<"line"> = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [{ data: [65, 59, 80, 81, 56, 55, 40], label: "Total Users" }],
  };
  public totalUsersOptions: ChartOptions = {
    scales: {
      y: {
        title: {
          display: true,
          text: "Number of Users",
        },
      },
    },
    responsive: true,
  };
  public totalUsersChartType: ChartType = "line";

  //TODO: why import StringFormatterService here, why not via imports?
  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone,
    private sf: StringFormatterService
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      UsersTotalConfig,
      _ngZone
    );

    this.handleDataSubscription(this.analyticsService.usersTotalDataChange);

    this.analyticsService.usersTotalDataChange.subscribe((data) => {
      this.setData(data);
    });

    this.analyticsService.userAnalyticsConfigurationChartDisplayOptionsChange.subscribe(
      () => {
        this.chartData.labels = this.totalUsersData.labels;
        this.chartData.datasets[0].data = this.totalUsersData.datasets[0].data;

        if(this.analyticsData?.labels) {
          this.analyticsData.labels = this.totalUsersData.labels;
        }
        this.analyticsData.data = this.totalUsersData.datasets[0].data;
        this.config.generalSettings.labels = this.totalUsersData.labels;
      }
    );
  }

  dataPointKey: string = "Total"; //I am here
  protected getDataPointDisplayValue(dataPoint: UserLineChartDataPoint): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.loggingService.log("TotalUsersChartComponent - buildFilterSettings");
    this.filterSettings.FilterByAllEmployees = "true";
    this.addPeriodtoFilterSettings();
    this.addPermissionsToFilterSettings();
  }

  refreshData(): void {
    /*
    this.filterSettings.FilterByStartDate = this.startDate;
    this.filterSettings.FilterByEndDate = this.endDate;
    this.filterSettings.FilterByDate = this.startDate;
    this.filterSettings.Period = TimePeriod.OneMonth;*/
    this.filterSettings.FilterByAllEmployees = "true";
    this.addPeriodtoFilterSettings();
    this.addPermissionsToFilterSettings();
    this.isLoading = true;
    this.loggingService.log("Getting Total Users Data");
    this.analyticsService.getTotalUsersData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected processDataForChart(data?: UsersTotalData) {
    // Call the parent method if needed
    this.setData(data);

    super.processDataForChart(data);

    this.loggingService.log(
      "Total Users Chart - processDataForChart - custom logic applied"
    );
  }

  private setData(data: UsersTotalData): void {
    if (data && data.DataPoints.length > 0) {
      this.isLoading = false;
      //aggregate data points on the daily level
      let dataPointsList = data.DataPoints;
      const aggregatedData: {
        RangeStart: string;
        RangeEnd: string;
        PermissionType: string;
        Total: number;
        PermissionGroups: UserLineChartDataPoint[];
      }[] = [];

      for (const dataPoint of dataPointsList) {
        let date = new Date(dataPoint.RangeStart);
        const formattedRangeStart = this.sf.formatDateTime(date);
        const formattedRangeEnd = this.sf.formatDateTime(
          new Date(dataPoint.RangeEnd)
        );
        // Add the previous date's points to the aggregated data
        aggregatedData.push({
          RangeStart: formattedRangeStart,
          RangeEnd: formattedRangeEnd,
          PermissionType: dataPoint.PermissionType,
          Total: dataPoint.Total,
          PermissionGroups: dataPoint.PermissionGroups,
        });
      }

      this.totalUsersData.labels = aggregatedData.map(
        (item) => item.RangeStart
      );
      this.totalUsersData.datasets[0].data = aggregatedData.map(
        (item) => item.Total
      );
      this.chartData.labels = aggregatedData.map((item) => item.RangeStart);
      this.chartData.datasets[0].data = aggregatedData.map(
        (item) => item.Total
      );
      this.config.generalSettings.labels = aggregatedData.map(
        (item) => item.RangeStart
      );
    }

    // TODO: Update y label based on aggregate filter here
    this.hasData = true;
  }

  getCustomLabel(dataPoint: UserLineChartDataPoint, label: string): any {
    const result_asTable: any[] = [];

    if (label === "Permission Groups") {
      const permissionGroups = dataPoint.PermissionGroups || [];

      // Optional: structured format for table display
      result_asTable.push(
        ...permissionGroups.map((pg) => ({
          PermissionType: pg.PermissionType,
          Total: pg.Total,
        }))
      );
    }

    return result_asTable;
  }
}
